<template>
  <mf-tooltip top variant="secondary">
    <template #activator="{ on }">
      <div class="status-chip" v-on="on">
        <v-icon small color="vermelho-0"> warning </v-icon>
        <span>{{ text }}</span>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </mf-tooltip>
</template>

<script>
export default {
  name: 'MissingProductsInfo',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    text() {
      return `${this.missingProductsQuantity} ${this.missingProductsQuantity > 1 ? 'falhas' : 'falha'}`
    },
    tooltip() {
      return `Falha na sincronização de ${this.missingProductsQuantity} ${
        this.missingProductsQuantity > 1 ? 'produtos' : 'produto'
      } com a campanha do e-commerce.`
    },
    missingProductsQuantity() {
      return this.item.external_synchronization.missing_products_quantity
    },
  },
}
</script>

<style lang="scss" scoped>
.status-chip {
  margin-left: 10px;
  border-radius: 4px;
  background-color: #f47f6833;
  color: $vermelho-d20;
  padding: 2px 6px 2px 4px;
  width: fit-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
</style>
